import React, { useState, useEffect } from 'react';
import { nestedSubgroupsAPI } from '../../utils/api';
import { FaImage, FaTrash, FaSearch, FaUpload } from 'react-icons/fa';
import '../../styles/AdminNestedSubgroups.css';

const AdminNestedSubgroups = () => {
  const [subgroups, setSubgroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [uploadingId, setUploadingId] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await nestedSubgroupsAPI.getAll();
      setSubgroups(response.data.data);
    } catch (error) {
      console.error('Ошибка загрузки подгрупп:', error);
      setMessage({ type: 'error', text: 'Ошибка загрузки данных' });
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (subgroupId, file) => {
    if (!file) return;

    setUploadingId(subgroupId);
    setMessage({ type: '', text: '' });

    try {
      const formData = new FormData();
      formData.append('image', file);

      await nestedSubgroupsAPI.uploadImage(subgroupId, formData);
      setMessage({ type: 'success', text: 'Картинка успешно обновлена' });
      loadData();
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Ошибка при загрузке картинки'
      });
    } finally {
      setUploadingId(null);
    }
  };

  const handleImageDelete = async (subgroupId) => {
    if (!window.confirm('Удалить картинку для этой подгруппы?')) return;

    setMessage({ type: '', text: '' });

    try {
      await nestedSubgroupsAPI.deleteImage(subgroupId);
      setMessage({ type: 'success', text: 'Картинка удалена' });
      loadData();
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Ошибка при удалении картинки'
      });
    }
  };

  const filteredSubgroups = subgroups.filter(sg =>
    sg.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    sg.nestedGroupId.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="admin-nested-subgroups-page">
      <div className="admin-nested-header">
        <h1>Картинки вложенных подгрупп</h1>
        <p className="header-description">
          Здесь можно установить общую картинку для вложенных подгрупп товаров.
          Эта картинка будет использоваться для всех товаров подгруппы,
          если у товара не установлена индивидуальная картинка.
        </p>
      </div>

      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="nested-controls">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Поиск по названию или ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="subgroups-count">
          Всего подгрупп: <strong>{filteredSubgroups.length}</strong>
        </div>
      </div>

      {loading ? (
        <div className="loading">Загрузка...</div>
      ) : filteredSubgroups.length === 0 ? (
        <div className="empty-state">
          <FaImage size={48} />
          <h3>Вложенные подгруппы не найдены</h3>
          <p>Подгруппы автоматически создаются при синхронизации товаров из 1С.</p>
        </div>
      ) : (
        <div className="subgroups-grid">
          {filteredSubgroups.map(sg => (
            <div key={sg._id} className="subgroup-card">
              <div className="subgroup-image-container">
                <img
                  src={sg.imageUrl || '/images/placeholder.jpg'}
                  alt={sg.name}
                  className="subgroup-image"
                  onError={(e) => e.target.src = '/images/placeholder.jpg'}
                />
                {sg.imageUrl && (
                  <div className="image-badge">✓ Установлена</div>
                )}
                {!sg.imageUrl && (
                  <div className="image-badge no-image">Нет картинки</div>
                )}
              </div>

              <div className="subgroup-info">
                <h3 className="subgroup-name" title={sg.name}>{sg.name}</h3>
                <span className="subgroup-id" title={sg.nestedGroupId}>
                  ID: {sg.nestedGroupId}
                </span>
              </div>

              <div className="subgroup-actions">
                <label className={`btn-upload ${uploadingId === sg._id ? 'uploading' : ''}`}>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={(e) => handleImageUpload(sg._id, e.target.files[0])}
                    disabled={uploadingId === sg._id}
                  />
                  <FaUpload />
                  {uploadingId === sg._id ? 'Загрузка...' : (sg.imageUrl ? 'Заменить' : 'Загрузить')}
                </label>

                {sg.imageUrl && (
                  <button
                    className="btn-delete-image"
                    onClick={() => handleImageDelete(sg._id)}
                    title="Удалить картинку"
                  >
                    <FaTrash />
                    Удалить
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminNestedSubgroups;
